const hideSavingDisplay = () => {
  setTimeout(() => {
    const elements = document.querySelectorAll("#savingDisplay");
    elements.forEach((element) => {
      element.classList.add("fadeout")
      element.classList.remove("pulsate")
    })
  }, 1000);

  setTimeout(() => {
    const elements = document.querySelectorAll("#savingDisplay");
    elements.forEach((element) => {
      element.classList.add("d-none")
      element.classList.remove("fadeout")
      element.classList.add("pulsate")
    })
  }, 3000);
}

const showSavingDisplay = () => {
  const elements = document.querySelectorAll("#savingDisplay");
  elements.forEach((element) => {
    element.classList.remove("d-none")
  })
}

export { hideSavingDisplay, showSavingDisplay }